import React from 'react';
import PropTypes from 'prop-types';
import { CreditCardImage } from './CreditCardImage';

export const expectedCreditCardTypeDisplayOrder = [
    'belk',
    'belk-mastercard',
    'jcpenney',
    'nordstrom',
    'ulta',
    'americanexpress',
    'dinersclub',
    'discovercard',
    'maestro',
    'mastercard',
    'visa'
];

export const defaultCreditCardTypes = ['visa', 'mastercard', 'discovercard', 'americanexpress'];

export const setCreditCardDisplayOrder = cardTypes =>
    expectedCreditCardTypeDisplayOrder.filter(creditCardType => cardTypes.includes(creditCardType));

export const CreditCardImagesDisplay = ({ cardTypes, selectedCard }) => {
    const orderedCardTypes = setCreditCardDisplayOrder(cardTypes);
    return (
        <div className="creditcard-container">
            {orderedCardTypes.map(card => (
                <CreditCardImage
                    card={card}
                    key={card}
                    isHighlighted={card === selectedCard}
                />
            ))
            }
        </div>
    );
};

CreditCardImagesDisplay.defaultProps = {
    cardTypes: defaultCreditCardTypes,
    selectedCard: ''
};

CreditCardImagesDisplay.propTypes = {
    cardTypes: PropTypes.array,
    selectedCard: PropTypes.string
};
